import { URGENCY_MESSAGE_GET_REQUEST } from '../actionTypes/UrgencyMessagingActionTypes';

const getUrgencyStatementsAction = (payload) => ({
    type: URGENCY_MESSAGE_GET_REQUEST,
    payload,
});

export default getUrgencyStatementsAction;
